import { registerLocaleData } from '@angular/common';
import { FormsModule } from '@angular/forms';
import {  APP_INITIALIZER, DEFAULT_CURRENCY_CODE,LOCALE_ID, NgModule } from '@angular/core';
import { authConfig } from '../environments/environment';
import { BrowserModule } from '@angular/platform-browser';
import { ReactiveFormsModule } from '@angular/forms';
import {OverlayModule} from '@angular/cdk/overlay';

import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';

import { HttpClientModule, HTTP_INTERCEPTORS } from '@angular/common/http';
import { ErrorsInterceptor } from './interceptors/errors.interceptor';
import { AuthConfig, OAuthModule, OAuthService } from 'angular-oauth2-oidc';
import { JwtInterceptor } from './interceptors/jwt.interceptor';
import  {LoginCallbackComponent} from './COMPOSANTS/login-callback/login-callback.component';
import { ConfirmationRegisterComponent } from 'extPafComponents/confirmation-register/confirmation-register.component';
import {SuppliersListComponent} from './ECRANS/TABLEAU_DE_BORD/user-dashboard/suppliers-list.component'
import { pafEnvironment } from 'localEnvironments/environment';

import { FolderSavedInfoComponent } from './ECRANS/folder-saved-info/folder-saved-info.component';
import {FolderSentToValidationComponent} from './ECRANS/folder-sent-to-validation/folder-sent-to-validation.component';

import "@progress/kendo-angular-intl/locales/fr/all";
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';

import { 
  SharedDataModule,
  PafCommonModule, 
  JsonDateInterceptor,
  ENV,
} from 'ngx-paf-common';

import localFr from '@angular/common/locales/fr';
import localEn from '@angular/common/locales/en';
import { OpenidLogoutComponent } from './COMPOSANTS/openid-logout/openid-logout.component';
import "@angular/compiler";
import { ShouldLoginComponent } from './ECRANS/should-login/should-login.component';
import { SvgIconComponent } from 'extPafComponents/svg-icon/svg-icon.component';
import { HomeComponent } from './COMPOSANTS/home/home.component';


export function initAuthFactory(oauthService: OAuthService) {
  return async (): Promise<void> => {
    oauthService.configure(authConfig);
    await oauthService.loadDiscoveryDocumentAndTryLogin();
    oauthService.setupAutomaticSilentRefresh(); // optionnel
  };
}

registerLocaleData(localFr);
registerLocaleData(localEn);

@NgModule({
  declarations: [
    AppComponent,
    FolderSavedInfoComponent,
    ConfirmationRegisterComponent,
    SuppliersListComponent,
    OpenidLogoutComponent,
    LoginCallbackComponent,
    FolderSentToValidationComponent,
    ShouldLoginComponent,
    SvgIconComponent,
    HomeComponent
  ],
  imports: [    
    SharedDataModule.forRoot(pafEnvironment),
    OAuthModule.forRoot(),
    PafCommonModule,
    BrowserModule,
    OverlayModule,
    AppRoutingModule,
    BrowserAnimationsModule,
    HttpClientModule,
    ReactiveFormsModule,
    NgbModule,
  ],
  providers: [
    { 
      provide: ENV, 
      useValue: pafEnvironment 
    },
    { 
      provide: LOCALE_ID, 
      useValue:'fr-FR'},
    {
      provide: APP_INITIALIZER,
      useFactory: initAuthFactory,
      deps: [OAuthService],
      multi: true
    },
    { 
      provide: HTTP_INTERCEPTORS, 
      useClass: ErrorsInterceptor
      , multi: true
    },
    {
      provide: HTTP_INTERCEPTORS, 
      useClass: JwtInterceptor, 
      multi: true
    },
    {
      provide: HTTP_INTERCEPTORS, 
      useClass: JsonDateInterceptor, 
      multi:true
    },
    {
      provide: DEFAULT_CURRENCY_CODE, 
      useValue: 'EUR'
    }
  ],
  bootstrap: [AppComponent]
})
export class AppModule { }
